export function isMissingAddressAutosaveError(err) {
    return err?.response?.status === 422
        && String(err?.response?.data?.error ?? '').includes('missing address');
}
